import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'accuracyPrice'})
export class AccuracyPricePipe implements PipeTransform {
  transform(value: number): number {
    return Math.round(value * 100) / 100;
  }
}
